import {forwardRef, ReactNode} from 'react'
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {WithTheme} from '@yosmanyga/theme'
import {NonExistentPrimitiveError, usePrimitives} from '@yosmanyga/primitive-ui-spec'

type ContainerProps = {
    intent?: string,

    onClick?: () => void,
    onLongPress?: () => void,
    onRawClick?: () => void,

    scrollable?: boolean,

    testId?: string,

    children?: ReactNode
}

const Container = forwardRef<
    unknown,
    ContainerProps
>(({
    children,
    ...props // Style props
}, ref) => {
    const {Container: BaseContainer} = usePrimitives()

    if (!BaseContainer) {
        throw new NonExistentPrimitiveError('Container')
    }

    // const show = !animation
    //     ? true
    //     : useDelayUnmount(animation?.active === 'enter', cssTimeToMilliseconds(animation.catalog.exit.unmount))
    const show = true;

    return show
        ? <BaseContainer
            ref={ref}
            // animation={animation?.catalog[animation.active]}
            {...props}
        >
            {children}
        </BaseContainer>
        : null
})

// const useDelayUnmount = (isMounted: boolean, delayTime: number) => {
//   const [shouldRender, setShouldRender] = useState(false)
//
//   useEffect(() => {
//     let id: NodeJS.Timeout
//
//     if (isMounted && !shouldRender) {
//       setShouldRender(true)
//     } else if (!isMounted && shouldRender) {
//       id = setTimeout(
//         () => setShouldRender(false),
//         delayTime
//       )
//     }
//
//     return () => clearTimeout(id)
//   }, [isMounted, delayTime, shouldRender])
//   return shouldRender
// }
//
// // https://gist.github.com/jakebellacera/9261266
// const cssTimeToMilliseconds = (time: string) => {
//   let unit
//
//   const match = time.match(/m?s/)
//
//   if (match) {
//     unit = match[0]
//   }
//
//   let milliseconds
//
//   const num = parseFloat(time)
//
//   switch (unit) {
//     case "s":
//       milliseconds = num * 1000
//
//       break
//     case "ms":
//       milliseconds = num
//
//       break
//     default:
//       milliseconds = 0
//
//       break
//   }
//
//   return milliseconds
// }

const ContainerWithTheme = forwardRef<unknown, ContainerProps & UnnormalizedStyleProps>((props, ref) => {
    return <WithTheme
        {...props}
        identifier='container'
        Component={Container}
        ref={ref}
    />
});

ContainerWithTheme.displayName = 'Container'

export default ContainerWithTheme
